import React from 'react'
import { Grid, Typography, Button, TextField } from '@mui/material'
import { ArrowBackIos } from '@mui/icons-material'
import i18n from 'i18n/index'
import { ReCAPTCHA } from 'react-google-recaptcha'

import RecoverSuccess from '../RecoverSuccess'
import ReCaptcha from 'components/Common/ReCaptcha'

type Props = {
  changeEmail: Function
  handleEnterKey: Function
  handleShowForgotPassword: () => void
  error: string
  forgotPassword: () => void
  email: string
  handlefinishRecoverPassword: () => void
  finishRecoverPassword: boolean
  captchaRef?: { current: ReCAPTCHA }
  errorRegister?: boolean
}

const FromForgotPassword = (props: Props) => {
  const {
    changeEmail,
    handleShowForgotPassword,
    error,
    forgotPassword,
    email,
    handlefinishRecoverPassword,
    finishRecoverPassword = false,
    errorRegister
  } = props

  if (finishRecoverPassword)
    return (
      <RecoverSuccess
        finishRecoverPassword={handlefinishRecoverPassword}
        message={i18n.t('responseRecoverPasswordSuccess')}
        email={email}
      />
    )

  return (
    <>
      <TextField
        id="input-forgot-password"
        aria-label="input-forgot-password"
        color="primary"
        variant="standard"
        label={i18n.t('whatEmailYouHave')}
        value={email}
        onChange={(e) => {
          const { value } = e.target
          changeEmail(value)
        }}
        error={Boolean(error)}
      />
      <Typography id="text-forgot-password-error" variant="subtitle1" color="error.light">
        {error}
      </Typography>
      <Grid container justifyContent="flex-start" alignItems="center" style={{ marginTop: 32 }}>
        <ReCaptcha captchaRef={props.captchaRef} />
      </Grid>
      {errorRegister ? (
        <Typography id="text-forgot-password-error" color="error.light" variant="subtitle1">
          Hay un error en el servidor, por favor intente más tarde, o contacta al equipo de soporte por medio del chat
        </Typography>
      ) : null}
      <Grid container justifyContent="space-between" alignItems="center" style={{ marginTop: 40 }}>
        <Button
          id="button-back-forgot-password"
          size="large"
          color="secondary"
          onClick={handleShowForgotPassword}
          startIcon={<ArrowBackIos sx={{ fontSize: '16px !important' }} />}
        >
          {i18n.t('back')}
        </Button>
        <Button
          id="button-validate-forgot-password"
          variant="contained"
          color="primary"
          size="large"
          onClick={forgotPassword}
          disabled={Boolean(!email)}
        >
          {i18n.t('validate')}
        </Button>
      </Grid>
    </>
  )
}

export default FromForgotPassword
